import { CircularProgress } from "@libs/zapi-ui/custom";
import { cn } from "@/zapi-frontend/shared/lib/utils";

type TProps = {
  isActive: boolean;
  isLoading: boolean;
};

export const SidebarDashboardIcon = (props: TProps) => {
  const { isActive, isLoading } = props;

  return (
    <div
      data-testid="sidebar-dashboard-icon"
      className={cn(
        "size-10 min-w-10 rounded-full flex justify-center items-center ml-1 transition-colors duration-300 group-hover:bg-innoveraRed-50",
        isActive && "bg-innoveraRed-50"
      )}
    >
      <div className="size-8 relative flex justify-center items-center">
        <CircularProgress
          withoutCheckMark
          progress={0}
          max={20}
          size={32}
          strokeWidth={1.5}
          color={isActive ? "var(--innovera-orange400)" : "var(--innovera-zinc200)"}
          trackColor={isActive ? "var(--innovera-orange300)" : "var(--innovera-zinc100)"}
          loading={isLoading}
        />
        <div className="absolute inset-0 flex justify-center items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M13.7069 6.79266L8.70688 1.79266C8.51936 1.60527 8.26511 1.5 8.00001 1.5C7.7349 1.5 7.48065 1.60527 7.29313 1.79266L2.29313 6.79266C2.19982 6.88528 2.12586 6.99552 2.07553 7.11698C2.02521 7.23844 1.99954 7.36869 2.00001 7.50016V13.5002C2.00001 13.6328 2.05268 13.7599 2.14645 13.8537C2.24022 13.9475 2.3674 14.0002 2.50001 14.0002H13.5C13.6326 14.0002 13.7598 13.9475 13.8536 13.8537C13.9473 13.7599 14 13.6328 14 13.5002V7.50016C14.0005 7.36869 13.9748 7.23844 13.9245 7.11698C13.8742 6.99552 13.8002 6.88528 13.7069 6.79266ZM13 13.0002H3.00001V7.50016L8.00001 2.50016L13 7.50016V13.0002Z"
              fill={isActive ? "#FF603E" : "var(--innovera-zinc900)"}
            />
          </svg>
        </div>
      </div>
    </div>
  );
};
